module.exports = __webpack_public_path__ + "static/media/ms-blue-logo.e365abc8.svg";